import { useEffect, useState } from 'react';
import { isBottomSheetViewport } from '@/lib/focusVisibility';

/** Keep all OCR dialogs on the same phone/tablet presentation breakpoint. */
export default function useBottomSheetViewport(active = true) {
  const [bottomSheetViewport, setBottomSheetViewport] = useState(isBottomSheetViewport);

  useEffect(() => {
    if (!active || typeof window === 'undefined') return undefined;

    const update = () => setBottomSheetViewport(isBottomSheetViewport());
    const pointerQueries = ['(pointer: coarse)', '(any-pointer: coarse)']
      .map(query => window.matchMedia?.(query))
      .filter(Boolean);
    const visualViewport = window.visualViewport;

    update();
    window.addEventListener('resize', update);
    window.addEventListener('orientationchange', update);
    visualViewport?.addEventListener('resize', update);
    pointerQueries.forEach(query => {
      if (query.addEventListener) query.addEventListener('change', update);
      else query.addListener?.(update);
    });

    return () => {
      window.removeEventListener('resize', update);
      window.removeEventListener('orientationchange', update);
      visualViewport?.removeEventListener('resize', update);
      pointerQueries.forEach(query => {
        if (query.removeEventListener) query.removeEventListener('change', update);
        else query.removeListener?.(update);
      });
    };
  }, [active]);

  return bottomSheetViewport;
}
